import React from 'react';
import '../Styles/Project.css';
import DigitalArt from '../Assets/DigitalArt.gif'
import PowerPuff from '../Assets/PPG.gif';
import DevDraw from '../Assets/DevDraw.gif'
import { FaGithub } from 'react-icons/fa';
import { FaRegWindowMaximize } from 'react-icons/fa'


export default function Projects() {
  return (
    <>
      <main className='project__container' id='projects'>
        <div className='project'>
          <img src={DigitalArt} alt='digital art project' />
          <div className='project__overlay'>
            <div className='project__text'>
              <h2> Digital Art </h2>
              <p> Full Stack Crud application </p>
              <div className='links'>
                <a href='https://github.com/DrummerDee/Digital-Art/blob/main/README.md' target='_blank' rel='noreferrer'> <FaGithub /> </a>
                <a href='https://digital-art-gal.herokuapp.com/' target='_blank' rel='noreferrer'> <FaRegWindowMaximize /> </a>
              </div>
            </div>
          </div>
        </div>
        <div className='project'>
          <img src='#' alt='wecare healthcare project' />
          <div className='project__overlay'>
            <div className='project__text'>
              <h2> WeCare Healthcare</h2>
              <p> Application with authenticated users </p>
              <div className='links'>
                <a href='https://github.com/DrummerDee/PPG-FrontEnd' target='_blank' rel='noreferrer'> <FaGithub /> </a>
                <a href='https://powerpuffapi.netlify.app' target='_blank' rel='noreferrer'> <FaRegWindowMaximize /> </a>
              </div>
            </div>
          </div>
        </div>
        <div className='project'>
          <img src={PowerPuff} className='ppg' alt='PowerPuff Girls api site video' />
          <div className='project__overlay'>
            <div className='project__text'>
              <h2> Power Puff Girls </h2>
              <p> API that fetches data from a server I created; backend is linked as well </p>
              <div className='links'>
                <a href='https://github.com/DrummerDee/PPG-FrontEnd' target='_blank' rel='noreferrer'> <FaGithub /> </a>
                <a href='https://powerpuffapi.netlify.app' target='_blank' rel='noreferrer'> <FaRegWindowMaximize /> </a>
              </div>
            </div>
          </div>
        </div>
        <div className='project'>
          <img src={DevDraw} alt='devdraw group canvas project' />
          <div className='project__overlay'>
            <div className='project__text'>
              <h2> Dev Draw</h2>
              <p> Collaborative project where users are met with instructions then taken to a blank canvas and tools </p>
              <div className='links'>
                <a href='https://github.com/DrummerDee/DevDrawApp' target='_blank' rel='noreferrer'> <FaGithub /> </a>
                <a href='https://devdraw.netlify.app/' target='_blank' rel='noreferrer'> <FaRegWindowMaximize /> </a>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  )
}
